import { CALL_API } from 'middleware/api';
/**
 * GET `/wealth/trading/pending-top-ups`
 *
 * THIS IS FOR EMMA WALLET
 *
 */
export const getPendingTopups = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/pending-top-ups',
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: ['GET_PENDING_TOPUPS_REQUEST', 'GET_PENDING_TOPUPS_SUCCESS', 'GET_PENDING_TOPUPS_ERROR'],
        muteAlert: true,
    },
});
export const pollPendingTopupsForTradingAccountId = (accountId) => ({
    type: 'POLL_PENDING_TOPUPS_FOR_TRADING_ACCOUNT_ID',
    accountId,
});
export const topUpSecclAccountUsingObCreated = () => ({
    type: 'TOP_UP_SECCL_ACCOUNT_USING_OB_CREATED',
});
/**
 *
 * THIS IS PENDING TOPUP FOR SECCL INVESTMENT ACCOUNT
 *
 */
export const getPendingTopupsForAccountId = (accountId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/accounts/${accountId}/transactions?status=Pending&transactionSubType=Deposit&excludeOrderFunding=true`,
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: [
            'GET_PENDING_TOPUPS_FOR_TRADING_ACCOUNT_REQUEST',
            'GET_PENDING_TOPUPS_FOR_TRADING_ACCOUNT_SUCCESS',
            'GET_PENDING_TOPUPS_FOR_TRADING_ACCOUNT_ERROR',
        ],
        extra: {
            accountId,
        },
        muteAlert: true,
    },
});
